import { api } from '../../axios-config';

/** O que a conta é em relação a eventos: as ferramentas de organizador aparecem com o 1º evento. */
export type EventAccess = {
  ownedEvents: number;
  delegatedEvents: number;
  openDrafts: number;
  maxOpenDrafts: number;
  canCreateEvent: boolean;
};

export type OrganizerProfile = {
  responsibleName: string;
  documentType: 'CPF' | 'CNPJ';
  documentMasked: string;
  phone: string;
  declarationVersion: string;
  acceptedAt: string;
  upToDate: boolean;
};

export type OrganizerProfileResponse = {
  profile: OrganizerProfile | null;
  declaration: { version: string; text: string };
};

export type OrganizerProfileInput = {
  responsibleName: string;
  document: string;
  phone: string;
  acceptDeclaration: boolean;
};

export type ChecklistKey = 'EMAIL_VERIFICADO' | 'DADOS_ORGANIZADOR' | 'CONTA_RECEBIMENTO';

export type PublishChecklist = {
  items: { key: ChecklistKey; done: boolean; label: string }[];
  canPublish: boolean;
  actorIsOwner: boolean;
};

export async function getEventAccess() {
  const response = await api.get<EventAccess>('/organizer/access');
  return response.data;
}

export async function getOrganizerProfile() {
  const response = await api.get<OrganizerProfileResponse>('/organizer/profile');
  return response.data;
}

export async function saveOrganizerProfile(data: OrganizerProfileInput) {
  const response = await api.put<OrganizerProfile>('/organizer/profile', data);
  return response.data;
}

export async function getPublishChecklist(eventId: string) {
  const response = await api.get<PublishChecklist>(
    `/organizer/events/${eventId}/publish-checklist`
  );
  return response.data;
}
